"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _style = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/style"));
var _logo = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/logo"));
var _items = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = () => {
  const show = /crm\.webmotors/.test(window.location.hostname);
  return show ? 'Menu' : _react.default.createElement("div", {
    "data-search": true
  });
};
exports.default = _default;